module.exports = __webpack_public_path__ + "19f1d0dff60aad9004ae476c88477ed8.svg";